// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file general/spoken_language.proto (package protos.general, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file general/spoken_language.proto.
 */
export const file_general_spoken_language: GenFile = /*@__PURE__*/
  fileDesc("Ch1nZW5lcmFsL3Nwb2tlbl9sYW5ndWFnZS5wcm90bxIOcHJvdG9zLmdlbmVyYWwq6QkKDlNwb2tlbkxhbmd1YWdlEhsKF1NQT0tFTl9MQU5HVUFHRV9VTktOT1dOEAASGgoWU1BPS0VOX0xBTkdVQUdFX0dFUk1BThABEhsKF1NQT0tFTl9MQU5HVUFHRV9FTkdMSVNIEAISGgoWU1BPS0VOX0xBTkdVQUdFX0FSQUJJQxADEhkKFVNQT0tFTl9MQU5HVUFHRV9PVEhFUhAEEh0KGVNQT0tFTl9MQU5HVUFHRV9CVUxHQVJJQU4QBRIbChdTUE9LRU5fTEFOR1VBR0VfQ0FUQUxBThAGEhsKF1NQT0tFTl9MQU5HVUFHRV9DSElORVNFEAcSGgoWU1BPS0VOX0xBTkdVQUdFX0tPUkVBThAIEhoKFlNQT0tFTl9MQU5HVUFHRV9DUkVPTEUQCRIaChZTUE9LRU5fTEFOR1VBR0VfREFOSVNIEAoSGgoWU1BPS0VOX0xBTkdVQUdFX0RPVUFMQRALEhsKF1NQT0tFTl9MQU5HVUFHRV9TUEFOSVNIEAwSGwoXU1BPS0VOX0xBTkdVQUdFX0ZJTk5JU0gQDRIbChdTUE9LRU5fTEFOR1VBR0VfRkxFTUlTSBAOEhoKFlNQT0tFTl9MQU5HVUFHRV9GUkVOQ0gQDxIZChVTUE9LRU5fTEFOR1VBR0VfR1JFRUsQEBIaChZTUE9LRU5fTEFOR1VBR0VfSEVCUkVXEBESGQoVU1BPS0VOX0xBTkdVQUdFX0hJTkRJEBISHQoZU1BPS0VOX0xBTkdVQUdFX0hVTkdBUklBThATEh0KGVNQT0tFTl9MQU5HVUFHRV9JTlVLVElUVVQQFBIbChdTUE9LRU5fTEFOR1VBR0VfSVRBTElBThAVEhwKGFNQT0tFTl9MQU5HVUFHRV9KQVBBTkVTRRAWEigKJFNQT0tFTl9MQU5HVUFHRV9RVUVCRUNfU0lHTl9MQU5HVUFHRRAXEhwKGFNQT0tFTl9MQU5HVUFHRV9NQUxBR0FTWRAYEhsKF1NQT0tFTl9MQU5HVUFHRV9NQUxJTktFEBkSHgoaU1BPS0VOX0xBTkdVQUdFX01PTlRBR05BSVMQGhIZChVTUE9LRU5fTEFOR1VBR0VfRFVUQ0gQGxIdChlTUE9LRU5fTEFOR1VBR0VfTk9SV0VHSUFOEBwSGgoWU1BPS0VOX0xBTkdVQUdFX1BPTElTSBAdEh4KGlNQT0tFTl9MQU5HVUFHRV9QT1JUVUdVRVNFEB4SHAoYU1BPS0VOX0xBTkdVQUdFX1JPTUFOSUFOEB8SGwoXU1BPS0VOX0xBTkdVQUdFX1JVU1NJQU4QIBIiCh5TUE9LRU5fTEFOR1VBR0VfU0VSQk9fQ1JPQVRJQU4QIRIdChlTUE9LRU5fTEFOR1VBR0VfU0xPVkVOSUFOECISGwoXU1BPS0VOX0xBTkdVQUdFX1NXRURJU0gQIxIZChVTUE9LRU5fTEFOR1VBR0VfQ1pFQ0gQJBIbChdTUE9LRU5fTEFOR1VBR0VfVFVSS0lTSBAlEh0KGVNQT0tFTl9MQU5HVUFHRV9VS1JBSU5JQU4QJhIeChpTUE9LRU5fTEFOR1VBR0VfVklFVE5BTUVTRRAnEhkKFVNQT0tFTl9MQU5HVUFHRV9XT0xPRhAoEhsKF1NQT0tFTl9MQU5HVUFHRV9ZSURESVNIECliBnByb3RvMw");

/**
 * @generated from enum protos.general.SpokenLanguage
 */
export enum SpokenLanguage {
  /**
   * @generated from enum value: SPOKEN_LANGUAGE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_GERMAN = 1;
   */
  GERMAN = 1,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_ENGLISH = 2;
   */
  ENGLISH = 2,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_ARABIC = 3;
   */
  ARABIC = 3,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_OTHER = 4;
   */
  OTHER = 4,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_BULGARIAN = 5;
   */
  BULGARIAN = 5,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_CATALAN = 6;
   */
  CATALAN = 6,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_CHINESE = 7;
   */
  CHINESE = 7,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_KOREAN = 8;
   */
  KOREAN = 8,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_CREOLE = 9;
   */
  CREOLE = 9,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_DANISH = 10;
   */
  DANISH = 10,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_DOUALA = 11;
   */
  DOUALA = 11,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_SPANISH = 12;
   */
  SPANISH = 12,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_FINNISH = 13;
   */
  FINNISH = 13,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_FLEMISH = 14;
   */
  FLEMISH = 14,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_FRENCH = 15;
   */
  FRENCH = 15,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_GREEK = 16;
   */
  GREEK = 16,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_HEBREW = 17;
   */
  HEBREW = 17,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_HINDI = 18;
   */
  HINDI = 18,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_HUNGARIAN = 19;
   */
  HUNGARIAN = 19,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_INUKTITUT = 20;
   */
  INUKTITUT = 20,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_ITALIAN = 21;
   */
  ITALIAN = 21,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_JAPANESE = 22;
   */
  JAPANESE = 22,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_QUEBEC_SIGN_LANGUAGE = 23;
   */
  QUEBEC_SIGN_LANGUAGE = 23,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_MALAGASY = 24;
   */
  MALAGASY = 24,

  /**
   * or Mandinka
   *
   * @generated from enum value: SPOKEN_LANGUAGE_MALINKE = 25;
   */
  MALINKE = 25,

  /**
   * or Innu
   *
   * @generated from enum value: SPOKEN_LANGUAGE_MONTAGNAIS = 26;
   */
  MONTAGNAIS = 26,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_DUTCH = 27;
   */
  DUTCH = 27,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_NORWEGIAN = 28;
   */
  NORWEGIAN = 28,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_POLISH = 29;
   */
  POLISH = 29,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_PORTUGUESE = 30;
   */
  PORTUGUESE = 30,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_ROMANIAN = 31;
   */
  ROMANIAN = 31,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_RUSSIAN = 32;
   */
  RUSSIAN = 32,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_SERBO_CROATIAN = 33;
   */
  SERBO_CROATIAN = 33,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_SLOVENIAN = 34;
   */
  SLOVENIAN = 34,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_SWEDISH = 35;
   */
  SWEDISH = 35,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_CZECH = 36;
   */
  CZECH = 36,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_TURKISH = 37;
   */
  TURKISH = 37,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_UKRAINIAN = 38;
   */
  UKRAINIAN = 38,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_VIETNAMESE = 39;
   */
  VIETNAMESE = 39,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_WOLOF = 40;
   */
  WOLOF = 40,

  /**
   * @generated from enum value: SPOKEN_LANGUAGE_YIDDISH = 41;
   */
  YIDDISH = 41,
}

/**
 * Describes the enum protos.general.SpokenLanguage.
 */
export const SpokenLanguageSchema: GenEnum<SpokenLanguage> = /*@__PURE__*/
  enumDesc(file_general_spoken_language, 0);

